<template>
  <v-content class="pa-12">
    <v-layout justify-space-around>
      <v-flex d-flex justify-start align-center style="color: #3E7662;font-weight: bold;font-size: 24px;">
        <span>โครงการที่รอระบุประเภทการพิจารณา</span>
      </v-flex>
    </v-layout>

    <!--search-->
    <v-row>
      <v-col cols="3">
        <v-text-field placeholder="รหัสโครงการวิจัย" color="#3e7662" dense outlined v-model="searchData.researchCode"
          hide-details />
      </v-col>
      <v-col cols="3">
        <v-text-field placeholder="ชื่อ นามสกุล ผู้วิจัย" color="#3e7662" dense outlined
          v-model="searchData.researcherName" hide-details />
      </v-col>
      <v-col cols="3">
        <v-text-field placeholder="เลขรับ" color="#3e7662" dense outlined v-model="searchData.initialNumber"
          hide-details />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="3">
        <v-select hide-details clearable :menu-props="{ bottom: true, offsetY: true }" background-color="#3e7662" dark
          solo flat dense label="ประเภทการพิจารณา" :items="considerationType" item-text="name" item-value="id"
          v-model="searchData.considerationType_id" />
      </v-col>
      <v-col cols="3">
        <v-text-field placeholder="ชื่อโครงการวิจัย" color="#3e7662" dense outlined v-model="searchData.researchName"
          hide-details />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="3">
        <DateInputForm :model="dateChange.startDate" @update-data="updateDate('startDate', $event)" label="ตั้งแต่">
        </DateInputForm>
      </v-col>
      <v-col cols="3">
        <DateInputForm :model="dateChange.endDate" @update-data="updateDate('endDate', $event)" label="จนถึง">
        </DateInputForm>
      </v-col>
      <v-col class="shrink d-flex justify-end">
        <v-btn color="#3e7662" dark @click="getResearchList(1)">
          <span class="font-weight-bold">ค้นหา</span>
        </v-btn>
      </v-col>
    </v-row>
    <!-- Table -->
    <v-layout mt-12>
      <v-flex>
        <form-table nameTable="โครงการวิจัยทั้งหมด" :headers="headers" :items="researchList" onViewData
          :on-send-mail="onSendMail" :typeConsideration="typeConsideration"></form-table>
      </v-flex>
    </v-layout>

    <!--Type of Consideration Modal-->
    <template>
      <v-row justify="center">
        <v-dialog flat v-model="typeConsiderationDialog" persistent max-width="60%">
          <v-layout py-3 px-6 style="background-color: #3E7662">
            <v-flex style="color: white;" shrink mr-3 justify-end align-center d-flex>
              <span>ระบุประเภทการพิจารณา</span>
            </v-flex>
          </v-layout>
          <v-card class="pb-3 pt-8" style="background-color: #FAFAFA">
            <v-card-text>
              <v-layout px-6>
                <v-flex style="font-weight: bold;font-size: 18px" shrink mr-3 justify-end align-center d-flex>
                  <span>เลือกประเภท</span>
                </v-flex>
              </v-layout>
              <!-- row 1 -->
              <v-layout mt-6 mb-12 px-6>
                <v-flex mr-3 align-center d-flex>
                  <v-radio-group hide-details v-model="researchForm.considerType" row>
                    <v-radio style="margin-right: 20px" color="#3E7662" label="1. ประเภท Full Board" value="1"></v-radio>
                    <v-radio style="margin-right: 20px" color="#3E7662" label="2. ประเภท Expedited" value="2"></v-radio>
                    <v-radio color="#3E7662" label="3. ประเภท Exemption" value="3"></v-radio>
                  </v-radio-group>
                </v-flex>
              </v-layout>
              <v-layout mt-12>
                <v-flex xs4 mr-4 pt-2 style="text-align: left;font-weight: bold;">
                  <span>ประเภทโครงร่างการวิจัย CREC/YMID</span>
                </v-flex>
                <v-flex xs4 pr-4 pt-2 style="text-align: left;font-weight: bold;">
                  <span>รหัสโครงร่างการวิจัย CREC/YMID</span>
                </v-flex>
                <v-flex xs3 pr-4 pt-2 style="text-align: left;font-weight: bold;">
                  <span>รหัสบริษัทยา</span>
                </v-flex>
              </v-layout>
              <v-layout pt-2>
                <v-flex xs4 pr-4>
                  <textfield-form readonly :model="researchForm.ymidtype"></textfield-form>
                </v-flex>
                <v-flex xs4 pr-4>
                  <textfield-form readonly :model="researchForm.ymidname"></textfield-form>
                </v-flex>
                <v-flex xs3 pr-4>
                  <textfield-form readonly :model="researchForm.protocol"></textfield-form>
                </v-flex>
              </v-layout>
              <div v-if="researchForm.considerType == 3">
                <v-layout class="my-8 px-6">
                  <v-flex class="text-start">
                    <span style="font-weight: bold;font-size: 18px;">กำหนดการอนุมัติ</span>
                  </v-flex>
                </v-layout>
                <v-layout ml-6>
                  <v-flex xs6 class="d-flex justify-center">
                    <DateInputForm :model="approvalDate" @update-data="updateDate('approvalDate', $event)">
                    </DateInputForm>
                  </v-flex>
                </v-layout>
                <v-layout class="my-8 px-6">
                  <v-flex class="text-start">
                    <span style="font-weight: bold;font-size: 18px;">RO 03_4_2563
                      แนวทางการทบทวนและนาเสนอโครงร่างการวิจัยแบบ Exemption</span>
                  </v-flex>
                </v-layout>
                <v-layout class="pb-4 px-6">
                  <v-flex shrink pt-2 pr-4 style="text-align: left;" class="align-center justify-end d-flex">
                    <span style="font-weight: bold;font-size: 16px;">ไฟล์</span>
                  </v-flex>
                  <v-flex xs4 class="align-center d-flex">
                    <v-file-input accept=".pdf" prepend-icon="" id="ro03_4File" :model="researchForm.ro03_4File" outlined
                      dense placeholder="Choose file" background-color="#FBF6F3" color="#3E7662" item-color="#3E7662"
                      @change="onUploadFile('ro03_4File', $event)" hide-details></v-file-input>
                  </v-flex>
                  <v-flex shrink pl-4 style="text-align: left">
                    <v-btn color="#3E7662" dark @click="onHandleBtn('ro03_4File')">
                      <v-icon class="pr-3">cloud_download</v-icon>
                      <span>Upload</span>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </div>
              <div v-else-if="researchForm.considerType == 2 || researchForm.considerType == 1">
                <v-layout>
                  <v-flex px-6>
                    <v-checkbox color="#3E7662" label="แก้ไขเพื่อรับรอง" value="1" v-model="researchForm.isResubmission">
                    </v-checkbox>
                  </v-flex>
                </v-layout>
              </div>
            </v-card-text>
            <v-card-actions style="margin-right: 6rem; margin-bottom: 1rem">
              <v-spacer></v-spacer>
              <v-btn width="100" class="mr-4" color="#fff" @click="typeConsiderationDialog = false">ยกเลิก</v-btn>
              <v-btn width="100" color="#3E7662" dark @click="updatetypeConsideration">บันทึก</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>

    <!-- Pagination -->
    <v-layout mt-12>
      <v-flex>
        <v-pagination color="#3E7662" :length="paginateResearch.last_page" :total-visible="9"
          @input="getResearchList($event)" v-model="paginateResearch.current_page"></v-pagination>
      </v-flex>
    </v-layout>
    <loading color="#527281" :active.sync="isLoading" :can-cancel="false" :is-full-page="fullPage"></loading>
  </v-content>
</template>

<script>
import Swal from "sweetalert2";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import FormTable from "../../components/table/FormTable";
import DateInputForm from "../../components/input/DateInputForm";
import { mapState, mapActions } from "vuex";
import axios from "axios";
import { domain } from "../../services/Constants";
import TextfieldForm from "../../components/input/TextfieldForm";

export default {
  components: {
    FormTable,
    Loading,
    DateInputForm,
    TextfieldForm
  },
  data: () => ({
    typeConsiderationDialog: false,
    researchForm: {
      month: "",
      otherMonth: "",
      researchID: "",
      considerType: "",
      approvalDate: "",
      isResubmission: null,
      ro03_4File: "",
      ymidtype: "",
      ymidname: "",
      protocol: ""
    },
    filterType: "4",
    paginateResearch: {
      current_page: 1,
      from: 1,
      last_page: 1,
      per_page: 1,
      total: 1,
      to: 1,
    },
    headers: [
      { text: "ลำดับ", value: "number", align: "center", sortable: false },
      {
        text: "ชื่องานวิจัย",
        value: "researchName",
        align: "center",
        sortable: false,
        width: "20%",
      },
      {
        text: "ชื่อผู้วิจัย",
        value: "researcherName",
        align: "center",
        sortable: false,
        width: "20%",
      },
      {
        text: "Version",
        value: "version",
        align: "center",
        sortable: false,
        width: "3%",
      },
      {
        text: "ประเภทการพิจารณา",
        value: "considerTypeShow",
        align: "center",
        sortable: false,
        width: "10%",
      },
      {
        text: "เลขรับ (Initial)",
        value: "initial",
        align: "center",
        sortable: false,
      },
      {
        text: "รหัสโครงการวิจัย",
        value: "code",
        align: "center",
        sortable: false,
        width: "8%",
      },
      {
        text: "ระบุประเภทการพิจารณา",
        value: "typeConsideration.",
        align: "center",
        sortable: false,
      },
      {
        text: "เลิอกคณะอนุกรรมการ",
        value: "selectSubcommittee",
        align: "center",
        sortable: false,
      },
      {
        text: "ส่งเข้าประเมิน",
        value: "mailSend",
        align: "center",
        sortable: false,
      },
      { text: "ดูข้อมูล", value: "view", align: "center", sortable: false },
    ],
    isLoading: false,
    fullPage: true,
    researchList: [],
    approvalDate: "",
    dateChange: {
      startDate: '',
      endDate: ''
    },
    considerationType: [
      { id: "0", value: "4", name: "ทั้งหมด", isResubmission: "0" },
      { id: "1", value: "1", name: "ประเภท Full Board", isResubmission: "0" },
      { id: "2", value: "2", name: "ประเภท Expedited", isResubmission: "0" },
      { id: "3", value: "3", name: "ประเภท Exemption", isResubmission: "0" },
      { id: "4", value: "1", name: "ประเภท Full Board (แก้ไขเพื่อรับรอง)", isResubmission: "1" },
      { id: "5", value: "2", name: "ประเภท Expedited (แก้ไขเพื่อรับรอง)", isResubmission: "1" },
    ],
    searchData: {
      startDate: '',
      endDate: '',
      researchCode: "",
      researcherName: "",
      considerationType_id: "0",
      considerType: "0",
      initialNumber: "",
      isResubmission: "0",
      researchName: ""
    },

  }),
  computed: {
    ...mapState({
      user: (state) => state.Auth.user,
    }),
  },
  created() {
    // Check Permission Access
    //   if (this.user.currentRole !== 2) {
    //       this.$router.go(-1);
    //   }
    this.getResearchList(1);
  },
  methods: {
    getResearchList(page) {
      // let data = {
      //   page: page,
      //   considerType: this.filterType,
      //   startDate: this.searchData.startDate,
      //   endDate: this.searchData.endDate
      // };
      this.searchData.page = page;
      let considerType = this.considerationType.find(x => x.id === this.searchData.considerationType_id);
      this.searchData.isResubmission = considerType.isResubmission
      this.searchData.considerType = considerType.value
      this.isLoading = true;
      this.researchList = [];
      this.$store
        .dispatch("Research/getVerifiedResearchList", this.searchData)
        .then((res) => {
          console.log('getVerifiedResearchList: ', res.data);
          let i = 1;
          res.data.forEach((data) => {
            this.researchList.push({
              number: i,
              researchName: data.thResearchName,
              researcherName:
                data.user.preNameTh ? data.user.preNameTh + " " + data.user.thName : data.user.thName,
              version: data.version,
              status: data.status,
              initial: data.initialNumber ? data.initialNumber : "-",
              code: data.researchCode ? data.researchCode : "-",
              type: data.type ? data.type : "-",
              considerTypeShow: data.research_type,
              considerType: data.considerType,
              oldVersionConsiderResult: data.oldVersionConsiderResult,
              ymidtype: data.ymidtype ? data.ymidtype : "-",
              ymidname: data.ymidname ? data.ymidname : "-",
              protocol: data.protocolNumber ? data.protocolNumber : "-",
              id: data.id,
              onView: 3,
              checkColor: data.choose_reviewer.length > 0 ? true : false,
              checkResearcherTypeID: data.researcherTypeID,
              checkMailSend: data.isSendReviewerMail == 1,
              isResubmission: data.isResubmission.toString(),
            });
            console.log('check');
            i++;
          });
          this.paginateResearch.current_page = res.current_page;
          this.paginateResearch.from = res.from;
          this.paginateResearch.last_page = res.last_page;
          this.paginateResearch.per_page = res.per_page;
          this.paginateResearch.total = res.total;
          this.paginateResearch.to = res.to;
          this.isLoading = false;
        })
        .catch((e) => {
          this.isLoading = false;
        });
    },
    onSendMail(researchID) {
      Swal.fire({
        title: "คุณต้องการส่งเข้าพิจารณาหรือไม่?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3E7662",
        cancelButtonColor: "rgb(189, 189, 189)",
        confirmButtonText: "ต้องการ",
        cancelButtonText: "ยกเลิก",
      }).then((result) => {
        if (result.value) {
          this.isLoading = true;
          this.$store
            .dispatch("Research/sendReviewerMail", researchID)
            .then((res) => {
              this.isLoading = false;
              Swal.fire({
                title: "บันทึกเรียบร้อยแล้ว",
                icon: "success",
                position: "center",
                showConfirmButton: false,
                timer: 1500,
              }).then(() => {
                this.getResearchList(1);
              });
            })
            .catch((e) => {
              this.isLoading = false;
              Swal.fire({
                title: "เกิดข้อผิดพลาด",
                text: "ส่ง E-mail ไม่สำเร็จ",
                icon: "warning",
              });
            });
        }
      });
    },
    updateDate(name, val) {
      if (name === "approvalDate") {
        this.researchForm.approvalDate = val.date;
        this.approvalDate = this.changeDate(val.date);
      } else {
        this.searchData[name] = val.date;
        this.dateChange[name] = this.changeDate(val.date);
      }
    },
    changeDate(val) {
      //change date start
      let sub_year = val.substring(0, 4);
      let sub_month = val.substring(5, 7);
      let sub_day = val.substring(8, 10);

      sub_year = parseInt(sub_year) + 543;

      let changeDate = sub_day + "/" + sub_month + "/" + sub_year;
      return changeDate;
    },
    typeConsideration(item) {
      console.log("item1", item);
      this.researchForm.researchID = item.id;
      this.researchForm.considerType = item.considerType
        ? item.considerType.toString()
        : "";
      this.typeConsiderationDialog = true;
      this.researchForm.isResubmission = item.isResubmission;
      this.researchForm.ymidtype = item.ymidtype;
      this.researchForm.ymidname = item.ymidname;
      this.researchForm.protocol = item.protocol;
      console.log(this.researchForm.isResubmission, item.isResubmission)
    },
    updatetypeConsideration() {
      this.isLoading = true;
      this.$store
        .dispatch("Research/updatetypeConsideration", this.researchForm)
        .then((res) => {
          this.isLoading = false;
          Swal.fire({
            title: "บันทึกเรียบร้อยแล้ว",
            icon: "success",
            position: "center",
            confirmButtonColor: "#3E7662",
            showConfirmButton: false,
            timer: 1500,
          }).then(() => {
            this.typeConsiderationDialog = false;
            this.getResearchList(1);
          });
        })
        .catch((e) => {
          this.isLoading = false;
        });
    },
    onUploadFile(fileName, e) {
      var formData = new FormData();
      formData.append(fileName, e);
      axios.post(domain + "/api/upload-file-pre", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
        .then((response) => {
          if (response.data.fileName !== undefined) {
            this.researchForm[fileName] = response.data.fileName;
          }
        })
        .catch(function (error) { });
    },
    onHandleBtn(index) {
      document.getElementById(index).click();
    },
  },
};
</script>

<style lang="scss">
.header-data-table {
  font-size: 20px;
}

.v-sheet {
  border-radius: 0 !important;
}
</style>
